import React, { useMemo, useCallback } from 'react';
import {
  Avatar,
  Box,
  ButtonIcon,
  InfoLabel,
} from '@cubeyou-team/hx-react-components';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { ProductsDropdown } from '@discover-frontend/components';

import { isEmpty } from 'src/utils';
import { SSO_URLS } from '../../constants/config';
import { showModal } from '../../actions';
import { selectFilteredUserProducts } from '../../selectors/products';
import { RepositoryActions } from '../../modules/repository/actions';

const StyledContainer = styled.div`
  background-color: ${props => props.theme.colors.dark};
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 8px;
`;

const StyledNotificationLabel = styled.div`
  position: absolute;
  top: 10px;
  right: -5px;
`;

const SSO_OVERVIEW_URL =
  process.env.REACT_APP_IS_LOCAL === 'true'
    ? SSO_URLS.localhost.REACT_APP_ID_SERVER_BASE
    : SSO_URLS[process.env.REACT_APP_API_ENV].REACT_APP_ID_SERVER_BASE;

const CollapsedHeader = ({ user, shareQuery, meProducts, showModal }) => {
  const { avatar } = user;
  const meProductFiltered =
    !meProducts.isLoading && selectFilteredUserProducts(meProducts.data);

  const getInitials = useMemo(() => {
    if (!user || !user.email) {
      return '';
    }

    if (user.name && user.surname) {
      return `${user.name.charAt(0)}${user.surname.charAt(0)}`;
    }

    return `${user.email.substring(0, 2)}`;
  }, [user]);

  const notifications = (shareQuery && shareQuery.data) || [];
  const notificationsToRead = notifications.filter(
    notification => !notification.read
  ).length;

  const handleUserMenuAction = useCallback(() => {
    showModal(
      {
        isOpen: true,
        position: 'right',
      },
      'UserPreview'
    );
  }, [showModal]);

  return (
    <StyledContainer>
      {isEmpty(meProductFiltered) ? (
        <ButtonIcon
          as="a"
          href={`${SSO_OVERVIEW_URL}/`}
          variant="light"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          icon="menu"
        />
      ) : (
        <ProductsDropdown
          dropdownPosition="right"
          products={meProductFiltered}
        />
      )}
      <Box style={{ paddingTop: '16px', paddingBottom: '30px' }}>
        <Avatar
          initials={getInitials}
          src={avatar}
          size="medium"
          onAvatarClick={() => handleUserMenuAction()}
          hoverEffect="standard"
        />
        {notificationsToRead > 0 && (
          <StyledNotificationLabel>
            <InfoLabel label={notificationsToRead} variant="error" />
          </StyledNotificationLabel>
        )}
      </Box>
      <RepositoryActions compact />
    </StyledContainer>
  );
};

const mapDispatchToProps = {
  showModal,
};

const mapStateToProps = state => ({
  shareQuery: state.shareQuery,
  meProducts: state.meProducts,
});

export default connect(mapStateToProps, mapDispatchToProps)(CollapsedHeader);
